import {
  InspectorControlsGeneral,
  InspectorControlsAppearance,
  InspectorTabs,
} from '@components/inspector-tabs';
import Visibility from '@components/visibility';
import { DEFAULT_CSS_CLASS } from '@constants';
import { title } from './block.json';
import {
  FocusableIcon,
  FocusableIconSwitcher,
} from '@components/focusable-block-icon';
import { accordionIcon } from './icons';
import classnames from 'classnames';
import './editor.scss';
const {
  i18n: { __ },
  blockEditor: { useBlockProps, useInnerBlocksProps, InspectorControls },
  element: { useEffect },
  components: { ToggleControl, PanelBody },
  compose: { useInstanceId },
} = wp;

const DEFAULT_BLOCKS_TEMPLATE = [
  ['b3rg/accordion-item-header', {}],
  ['b3rg/accordion-item-body', {}],
];
const FLOAT_PANEL_BLOCKS_TEMPLATE = [
  ['b3rg/accordion-item-header', {}],
  ['b3rg/accordion-item-body', {}],
  ['b3rg/accordion-float-panel', {}],
];
const Edit = ({ attributes, setAttributes, clientId, context }) => {
  const {
    allowedBlocks,
    blockVisibility,
    expandDefault,
    uniqueID,
    enableFocusableIcon,
  } = attributes;
  const { floatPanel, expandAll } = context;

  const defaultBlockCssClass = DEFAULT_CSS_CLASS.ACCORDION;

  const blockProps = useBlockProps({
    className: classnames({
      [`${defaultBlockCssClass}__itm`]: true,
      disable: !blockVisibility,
    }),
  });
  const instanceId = useInstanceId(Edit, `${defaultBlockCssClass}-itm-id`);

  useEffect(() => {
    setAttributes({ uniqueID: instanceId, isExpandAll: expandAll });
  }, [clientId, instanceId, expandAll, setAttributes]);

  const { children, ...innerBlocksProps } = useInnerBlocksProps(blockProps, {
    allowedBlocks,
    template: floatPanel
      ? FLOAT_PANEL_BLOCKS_TEMPLATE
      : DEFAULT_BLOCKS_TEMPLATE,
    templateLock: 'all',
  });

  const accItmWrprClasses = classnames({
    [`${defaultBlockCssClass}__itm-wrpr`]: true,
    'has-focusable-icon': enableFocusableIcon,
    active: expandDefault,
  });

  return (
    <>
      <InspectorControls>
        <InspectorTabs>
          <InspectorControlsGeneral>
            <Visibility {...{ blockVisibility, setAttributes }} />
            <PanelBody title={__('Accordion Item Settings', 'b3rg')}>
              <ToggleControl
                label={__('Default Expand')}
                checked={expandDefault}
                onChange={(newValue) => {
                  setAttributes({
                    expandDefault: newValue,
                  });
                }}
              />
            </PanelBody>
          </InspectorControlsGeneral>
          <InspectorControlsAppearance>
            <FocusableIconSwitcher
              {...{
                enableFocusableIcon,
                setAttributes,
              }}
            />
          </InspectorControlsAppearance>
        </InspectorTabs>
      </InspectorControls>
      <div className={accItmWrprClasses} data-item-id={uniqueID}>
        <div {...innerBlocksProps}>
          {enableFocusableIcon && (
            <FocusableIcon {...{ title, icon: accordionIcon }} />
          )}
          {children}
        </div>
      </div>
    </>
  );
};

export default Edit;
